import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-clear.tsx
/**
* icon.24.clear
*
* Keywords: close, dismiss, cancel, circle, exit, remove
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyIDVhNyA3IDAgMSAxIDAgMTQgNyA3IDAgMCAxIDAtMTRtMCAxYTYgNiAwIDEgMCAwIDEyIDYgNiAwIDAgMCAwLTEybTIuMjI1IDMuMDgyYS41LjUgMCAwIDEgLjY5My42OTNsLS4wNjQuMDc5TDEyLjcwNyAxMmwyLjE0NyAyLjE0Ni4wNjQuMDc5YS41LjUgMCAwIDEtLjY5My42OTNsLS4wNzgtLjA2NEwxMiAxMi43MDdsLTIuMTQ2IDIuMTQ2YS41LjUgMCAxIDEtLjcwNy0uNzA3TDExLjI5MyAxMiA5LjE0NyA5Ljg1NGwtLjA2NS0uMDc5YS41LjUgMCAwIDEgLjY5NC0uNjkzbC4wNzguMDY0TDEyIDExLjI5M2wyLjE0Ny0yLjE0N3oiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=7369-8610
*/
const Icon24Clear = memo(function Icon24Clear(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12 5a7 7 0 1 1 0 14 7 7 0 0 1 0-14m0 1a6 6 0 1 0 0 12 6 6 0 0 0 0-12m2.225 3.082a.5.5 0 0 1 .693.693l-.064.079L12.707 12l2.147 2.146.064.079a.5.5 0 0 1-.693.693l-.078-.064L12 12.707l-2.146 2.146a.5.5 0 1 1-.707-.707L11.293 12 9.147 9.854l-.065-.079a.5.5 0 0 1 .694-.693l.078.064L12 11.293l2.147-2.147z"
		})
	});
});
//#endregion
export { Icon24Clear };

//# sourceMappingURL=icon-24-clear.js.map